import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-accent-500 uppercase tracking-wider mb-2">USER REVIEWS</p>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900">读者好评</h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-lg mx-auto">
            来看看吃瓜群众们对吃瓜网站的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {commentsData.map((comment, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-500">{comment.time}</p>
                </div>
                <div className="flex items-center gap-1 text-foreground-400">
                  <i className="ri-heart-line text-xs"></i>
                  <span className="text-xs">{comment.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}